import { gql } from '@apollo/client';
import userLicenseFragment from '../userLicenseFragment';

const GET_FREE_USERS = gql`
  query GetFreeUsers($organizationId: Int, $orgUnitId: Int) {
    freeUsers(organizationId: $organizationId, orgUnitId: $orgUnitId) {
      ...UserLicenseFields
    }
    licenseInformation(organizationId: $organizationId, orgUnitId: $orgUnitId) {
      Organization {
        licenseTotal: FreeTotal
        licenseAssigned: FreeAssigned
      }
      OrgUnits {
        OrgUnitId
        OrgUnitName
        licenseTotal: FreeTotal
        licenseAssigned: FreeAssigned
      }
    }
  }

  ${userLicenseFragment}
`;

export default GET_FREE_USERS;
